<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33333 12.6667V11.3333C9.33333 10.8029 9.12247 10.2943 8.7474 9.91927C8.37232 9.5442 7.86377 9.33333 7.33333 9.33333H3.33333C2.8029 9.33333 2.29434 9.5442 1.91927 9.91927C1.5442 10.2943 1.33333 10.8029 1.33333 11.3333V12.6667C1.33333 13.0349 1.03486 13.3333 0.666667 13.3333C0.298477 13.3333 0 13.0349 0 12.6667V11.3333C0 10.4493 0.351441 9.60168 0.976563 8.97656C1.60168 8.35144 2.44928 8 3.33333 8H7.33333C8.21739 8 9.06498 8.35144 9.6901 8.97656C10.3152 9.60168 10.6667 10.4493 10.6667 11.3333V12.6667C10.6667 13.0349 10.3682 13.3333 10 13.3333C9.63181 13.3333 9.33333 13.0349 9.33333 12.6667ZM13.3333 12.6667V11.334L13.3262 11.1686C13.2941 10.7845 13.1516 10.4165 12.9141 10.11C12.6426 9.7598 12.2624 9.50922 11.8333 9.39844C11.4769 9.30636 11.2628 8.94306 11.3548 8.58659C11.4469 8.23014 11.8102 8.01603 12.1667 8.10807C12.8817 8.29272 13.5156 8.70927 13.9681 9.29297C14.4205 9.87664 14.6661 10.5942 14.6667 11.3327V12.6667C14.6666 13.0348 14.3682 13.3333 14 13.3333C13.6318 13.3333 13.3334 13.0348 13.3333 12.6667ZM7.33333 3.33333C7.33333 2.22876 6.4379 1.33333 5.33333 1.33333C4.22876 1.33333 3.33333 2.22876 3.33333 3.33333C3.33333 4.4379 4.22876 5.33333 5.33333 5.33333C6.4379 5.33333 7.33333 4.4379 7.33333 3.33333ZM11.3307 3.33333C11.3307 2.89034 11.1838 2.45975 10.9128 2.10937C10.6416 1.75898 10.2616 1.50832 9.83268 1.39714C9.47631 1.30472 9.26243 0.941025 9.35482 0.584635C9.44724 0.22826 9.81093 0.0143781 10.1673 0.106771C10.8821 0.292086 11.5149 0.709635 11.9668 1.29362C12.4187 1.87761 12.6641 2.59493 12.6641 3.33333C12.6641 4.07174 12.4187 4.78906 11.9668 5.37305C11.5149 5.95704 10.8821 6.37458 10.1673 6.5599C9.81096 6.65228 9.44728 6.43835 9.35482 6.08203C9.26243 5.72565 9.47632 5.36196 9.83268 5.26953C10.2616 5.15835 10.6416 4.90769 10.9128 4.55729C11.1839 4.20692 11.3307 3.77634 11.3307 3.33333ZM8.66667 3.33333C8.66667 5.17428 7.17428 6.66667 5.33333 6.66667C3.49238 6.66667 2 5.17428 2 3.33333C2 1.49238 3.49238 0 5.33333 0C7.17428 0 8.66667 1.49238 8.66667 3.33333Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'UserGroupIcon',
  props: {
    size: {
      type: [Number, String],
      default: 11
    },
    fill: {
      type: String,
      default: '#62676D'
    }
  }
};
</script>
